import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Tag,
  Input,
  Button,
  Modal,
  Form,
  Select,
  Upload,
  message,
  Pagination
} from "antd";
import { UploadOutlined ,SearchOutlined, EnvironmentOutlined} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.extend(relativeTime);

const JobsStudent = () => {
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [jobSearch, setJobSearch] = useState("");
const [locationSearch, setLocationSearch] = useState("");
const [positionType, setPositionType] = useState("");

const [currentPage, setCurrentPage] = useState(1);
const pageSize = 15;

  const navigate = useNavigate();   

  const [form] = Form.useForm();

  const token = localStorage.getItem("token");

  const fetchJobs = async () => {
  try {
    
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/jobs/all`,
      {
        headers: { Authorization: `Bearer ${token}`},
      }
    );

    if (res.data.success) {
      const jobsData = res.data.data;
      setJobs(jobsData);
    }
  } catch (err) {
    console.error("❌ Fetch Jobs Error:", err);
  }
};

useEffect(() => {
  fetchJobs();
}, []);

 

const filteredJobs = jobs.filter((job) => {
  const titleMatch = job.JobTitle?.toLowerCase().includes(
    jobSearch.toLowerCase()
  );

  const locationMatch = job.Location?.toLowerCase().includes(
    locationSearch.toLowerCase()
  );

  const positionMatch = positionType
    ? job.PositionType?.toLowerCase() === positionType.toLowerCase()
    : true;

  return titleMatch && locationMatch && positionMatch;
});

const paginatedJobs = filteredJobs.slice(
  (currentPage - 1) * pageSize,
  currentPage * pageSize
);

  return (
    <div className="p-6">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-slate-800">
          All Jobs
        </h1>

        {/* POST JOB BUTTON */}
        {/* <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          className="font-semibold text-md"
        >
          + Post a Job
        </Button> */}
      </div>

      {/* SEARCH */}
   <div className="p-5 mb-6 border shadow-sm bg-white/80 backdrop-blur rounded-2xl">

  {/* HEADER */}
  <div className="mb-4">
    <h2 className="text-lg font-semibold text-slate-800">
      Search Jobs
    </h2>
    <p className="text-sm text-gray-500">
      Filter jobs by Job Title , Location , Position Type 
    </p>
  </div>

  {/* INPUTS */}
 <div className="grid grid-cols-1 gap-4 md:grid-cols-4">

  {/* JOB TITLE */}
  <div>
    <label className="block mb-1 text-xs font-semibold text-gray-500">
      Job Title
    </label>
    <Input
      placeholder="e.g. React Developer"
      className="h-11 rounded-xl"
      value={jobSearch}
      onChange={(e) => setJobSearch(e.target.value)}
    />
  </div>

  {/* LOCATION */}
  <div>
    <label className="block mb-1 text-xs font-semibold text-gray-500">
      Location
    </label>
    <Input
      placeholder="e.g. Bangalore / Remote"
      className="h-11 rounded-xl"
      value={locationSearch}
      onChange={(e) => setLocationSearch(e.target.value)}
    />
  </div>

  {/* POSITION TYPE */}
  <div>
    <label className="block mb-1 text-xs font-semibold text-gray-500">
      Position Type
    </label>
    <Select
      placeholder="Select Position Type"
      className="w-full h-11 rounded-xl"
      value={positionType || undefined}
      onChange={(value) => setPositionType(value || "")}
      allowClear
      size="large"
    >
      <Select.Option value="FRESHER">FRESHER</Select.Option>
      <Select.Option value="EXPERIENCE">EXPERIENCE</Select.Option>
      
    </Select>
  </div>

  {/* CLEAR BUTTON */}
  <div className="flex items-end">
    <Button
      onClick={() => {
        setJobSearch("");
        setLocationSearch("");
        setPositionType("");
      }}
      className="w-full font-medium h-11 rounded-xl"
    >
      Clear Filters
    </Button>
  </div>

</div>

</div>

      {/* JOB LIST */}
      <div className="space-y-5">
       {paginatedJobs.map((job) => (
            
          <Card key={job.id} className="transition border rounded-2xl hover:shadow-md">
            <div className="flex items-start justify-between">

              {/* LEFT */}
              <div className="flex gap-4">

                <img
                  src={job.CompanyLogo}
                  alt="logo"
                  className="object-cover w-12 h-12 rounded-md"
                />

                <div>
                    <div className="flex items-center gap-3">

  <h2
    onClick={() =>
      navigate(`/academy/mentee-dashboard/jobs/${job.id}/job-details`)
    }
    className="text-lg font-semibold cursor-pointer text-slate-800 hover:text-blue-600 hover:underline"
  >
    {job.JobTitle}
  </h2>

  {/* Position Type Tag */}
  {job.PositionType && (
   <span
  className={`px-2 py-1 text-xs font-semibold rounded-md border flex items-center gap-1 ${
    job.PositionType.toUpperCase() === "FRESHER"
      ? "bg-green-50 text-green-600 border-green-200"
      : "bg-blue-50 text-blue-600 border-blue-200"
  }`}
>
  {job.PositionType.toUpperCase() === "FRESHER" ? "🟢" : "🔵"} {job.PositionType.toUpperCase()}
</span>
  )}

</div>

                  <p className="text-sm text-gray-500">
                    {job.CompanyName} • {job.WorkPreference} • {job.Location}
                  </p>

                  {/* EXPERIENCE */}
                  <p className="mt-1 text-sm text-gray-600">
                    <span className="font-semibold text-gray-500">Experience Required : </span>{job.Experience}
                  </p>

                 
                  {/* SKILLS */}
                  <div className="flex flex-wrap gap-2 mt-3">
  {job.RequiredSkills?.split(",").map((skill, i) => {
    const colors = [
      "bg-blue-50 text-blue-600 border-blue-200",
      "bg-green-50 text-green-600 border-green-200",
      "bg-purple-50 text-purple-600 border-purple-200",
      "bg-orange-50 text-orange-600 border-orange-200",
      "bg-pink-50 text-pink-600 border-pink-200",
      "bg-indigo-50 text-indigo-600 border-indigo-200",
    ];

    const colorClass = colors[i % colors.length];

    return (
      <span
        key={i}
        className={`px-3 py-1 text-xs font-semibold border rounded-md ${colorClass} transition hover:shadow-sm`}
      >
        {skill.trim()}
      </span>
    );
  })}
</div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="flex flex-col items-end gap-3">
               <p className="text-xs font-semibold text-gray-500">
  {dayjs(job.CreatedAt)
    .add(5, "hour")
    .add(30, "minute")
    .fromNow()}
</p>

                 <Button
                   type="primary"
                   onClick={() => {
                     const website = job.Website?.trim();
                 
                     if (website && website !== "null" && website !== "undefined") {
                       window.open(website, "_blank");
                     } else if (job.ContactEmail) {
                       window.location.href = `mailto:${job.ContactEmail}`;
                     } else {
                       alert("No application method available");
                     }
                   }}
                 >
                   Apply
                 </Button>
              </div>

            </div>
          </Card>
        ))}
      </div>

     
<div className="flex justify-center mt-10">

  <Pagination
    current={currentPage}
    pageSize={pageSize}
    total={filteredJobs.length}
    onChange={(page) => setCurrentPage(page)}
    showSizeChanger={false}
    className="custom-pagination"
  />

</div>

    </div>
  );
};

export default JobsStudent;